import { GetPerkById } from "../constants/perks";
import { SPGameState } from "../enum/GameState";
import { SoundByte } from "../enum/sounds";
import MonoBehavior from "../lib/MonoBehavior";
import { Time } from "../lib/Time";
import Vector2 from "../math/Vector2";
import { clamp01 } from "../util";
import Color from "../util/Color";
import { Random } from "../util/Random";
import DialogueManager from "./DialogueManager";
import ExpOrb from "./ExpOrb";
import { ForceFieldBehavior } from "./SPAbilities/ForceField";
import SPBogey from "./SPBogey";
import SPBullet from "./SPBullet";
import Diver from "./SPEnemies/Diver";
import Hive from "./SPEnemies/Hive";
import SmartBogey from "./SPEnemies/SmartBogey";
import Tanker from "./SPEnemies/Tanker";
import Wolf from "./SPEnemies/Wolf";
import Worm from "./SPEnemies/Worm";
import WormMaster from "./SPEnemies/WormMaster";
import SPGameManager from "./SPGameManager";
import SPGun from "./SPGun";
import SPPlayer from "./SPPlayer";

export default class SPSpawnManager extends MonoBehavior {

    born = Time.time;
    get timeAlive() {return Time.time - this.born;}
    active = false;

    events: {
        delay: number;
        callback: () => void;
    }[] = [
        //#region sequence 1
        {
            delay: 0.1,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.BGM1);
                SPGameManager.Singleton.SetTitleText("Welcome");
                // for (let i = 0; i < 800; i++) {
                //     this.engine.NewGameObjectWithScript(ExpOrb, {
                //         position: SPPlayer.Singleton.transform.position.add(Vector2.up.scale(200))
                //     });
                // }

                // this.engine.NewGameObjectWithScript<Hive>(Hive, {
                //     initialValues: {
                //         isBoss: true
                //     }
                // });

                // SPPlayer.Singleton.cameraLocked = false;
                // SPPlayer.Singleton.planeControls = true;
                // SPPlayer.Singleton.godMode = true;
                // SPPlayer.Singleton.gun.damage = 100;
            }
        },
        {
            delay: 3,
            callback: () => {
                SPGameManager.Singleton.SetTitleText(` W
ASD

Move`, {
                    stay: 1
                });
            }
        },
        {
            delay: 5,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("Mouse1 - Fire\nR - Reload", {
                    stay: 5
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
                this.engine.NewGameObjectWithScript<SPBogey>(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 1
                    }
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("Bogeys drop experience upon defeat", {
                    stay: 5/4
                });
            }
        },
        {
            delay: 5/4+2,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("Every level you get a new perk", {
                    stay: 7/4
                });
            }
        },
        {
            delay: 7/4+2,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("Most bogeys will shoot back at you", {
                    stay: 7/4
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("If you are hit, you will lose experience\nDe-leveling locks your perks", {
                    stay: 12/4
                });
            }
        },
        {
            delay: 12/4+2,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("When all your experience is drained,\nyou can only take 3 hits before you die.", {
                    stay: 15/4
                });
            }
        },
        {
            delay: 15/4+2,
            callback: () => {
                this.engine.NewGameObjectWithScript(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        
        {
            delay: 8/4+2,
            callback: () => {
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        {
            delay: 1,
            callback: () => {
                SPGameManager.Singleton.SetTitleText("Every 5 rounds, you will face a boss.", {
                    stay: 8/4
                });
            }
        },
        //boss 1
        {
            delay: 8/4+2,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.BossMusic1, 0, 0.5);
                
                this.engine.NewGameObjectWithScript(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        isBoss: true,
                        name: "Big Bogey",
                        xpReward: 15,
                        fireRate: 2,
                        size: 16,
                        hp: 20,
                        maxHP: 20
                    }
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        //#endregion
        
        //#region sequence 2
        {
            delay: 8/4+2,
            callback: () => {

                SPGameManager.Singleton.ChangeBGM(SoundByte.BGM2);

                this.engine.NewGameObjectWithScript(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 4,
                        fireRate: 3,
                        hp: 10,
                        maxHP: 10
                    }
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        {
            delay: 5,
            callback: () => {
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
            }
        },
        {
            delay: 5,
            callback: () => {
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 4,
                        fireRate: 3,
                        hp: 10,
                        maxHP: 10
                    }
                });
            }
        },
        {
            delay: 5,
            callback: () => {
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        //boss 2
        {
            delay: 4,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.WormSong);
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        isBoss: true,
                        name: "7H3 W02-M",
                        xpReward: 5,
                        fireRate: 0,
                        size: 16,
                        hp: 10,
                        maxHP: 10,
                        segments: 30
                    }
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        isBoss: true,
                        name: "3U1L W02-M",
                        xpReward: 5,
                        fireRate: 0,
                        size: 16,
                        hp: 10,
                        maxHP: 10,
                        segments: 30
                    }
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: new Vector2(-10000, -10000),
                    initialValues: {
                        xpReward: 1,
                        fireRate: 0,
                        hp: 1,
                        maxHP: 1,
                        segments: 15
                    }
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460))
                });
            }
        },
        //#endregion

        //#region Sequence 3
        {
            delay: 5,
            callback: () => {
                SPGameManager.Singleton.StopBGM();
                DialogueManager.Singleton.Open("Not bad. That thing has taken out entire fleets, yet here you are—alive. Impressive.");
            }
        },
        {
            delay: 5,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.WolfIntro);
                this.engine.NewGameObjectWithScript(Wolf, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.up.scale(600))
                });
            }
        },
        {
            delay: 5,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.BGM3);
                SPPlayer.Singleton.cameraLocked = false;
                this.engine.NewGameObjectWithScript(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(SPBogey, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 20,
                        hp: 50,
                        maxHP: 50
                    }
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 20,
                        hp: 50,
                        maxHP: 50
                    }
                });
            }
        },
        {
            delay: 0,
            callback: () => {
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Tanker, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 20,
                        hp: 50,
                        maxHP: 50
                    }
                });
            }
        },
        {
            delay: 3,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.Hive);
                this.engine.NewGameObjectWithScript<Hive>(Hive, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980)),
                    initialValues: {
                        isBoss: true
                    }
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(Diver, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript(WormMaster, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980))
                });
                this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 20,
                        hp: 50,
                        maxHP: 50
                    }
                });
                this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 20,
                        hp: 50,
                        maxHP: 50
                    }
                });
            }
        },
        //#endregion
        
        //#region Sequence 4
        {
            delay: 3,
            callback: () => {
                SPPlayer.Singleton.cameraLocked = true;
                const dialogue =  DialogueManager.Singleton;
                dialogue.Open("Wolf, we are closing in on your position. Over.", {
                    name: "???"
                });
                if (!SPGameManager.Singleton.bWolfKilledEarly) {
                    dialogue.listener.once("onClose", () => {
                        dialogue.Open("Copy that. I have someone for you to meet.", {
                            name: "W0lf"
                        });
                    });
                }
            }
        },
        {
            delay: 5,
            callback: () => {
                const dialogue =  DialogueManager.Singleton;
                if (SPGameManager.Singleton.bWolfKilledEarly) {
                    SPGameManager.Singleton.ChangeBGM(SoundByte.WolfBattle);
                    dialogue.Open("Wait a minute... You're not Wolf. What did you do with him?", {
                        name: "BULLDOG"
                    });
                }
                this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 100,
                        isBoss: true,
                        name: "Codename: BULLDOG",
                        isFriendly: !SPGameManager.Singleton.bWolfKilledEarly
                    }
                });
                const [,falcon] = this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                    position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                    initialValues: {
                        xpReward: 100,
                        color: new Color(255,255,85),
                        fireRate: 1,
                        isBoss: true,
                        name: "Codename: FALCON",
                        isFriendly: !SPGameManager.Singleton.bWolfKilledEarly
                    }
                });

                falcon.gun = new SPGun(falcon, {
                    bulletSpeed: 600,
                    damage: 4,
                    fireRate: 1,
                    magSize: 8,
                    mouseTrigger: 0,
                    reloadTime: 1.5,
                    maxEnemiesHit: 2
                });

                if (!SPGameManager.Singleton.bWolfKilledEarly && !this.engine.GetGameObjectsBehaviors(Wolf).length) {
                    const [,wolf] = this.engine.NewGameObjectWithScript<SmartBogey>(SmartBogey, {
                        position: SPPlayer.Singleton.transform.position.add(new Vector2(Random.int(-300, 300), -460)),
                        initialValues: {
                            xpReward: 100,
                            color: new Color(26, 237, 170),
                            fireRate: 3,
                            isBoss: true,
                            name: "Codename: WOLF"
                        }
                    });
    
                    wolf.gun = new SPGun(wolf, {
                        bulletSpeed: 200,
                        damage: 1,
                        fireRate: 3,
                        magSize: 30,
                        mouseTrigger: 0,
                        reloadTime: 1,
                        maxEnemiesHit: 1
                    });
    
                    wolf.gun.onShoot = () => {
        
                        const center = wolf.transform.position.add(wolf.transform.forward.scale(wolf.size + 3));
        
                        wolf.engine.NewGameObjectWithScript(SPBullet, {
                            position: center.add(wolf.transform.left.scale(4)),
                            initialValues: {
                                damage: wolf.gun.damage,
                                velocity: wolf.velocity.add(wolf.transform.forward.scale(wolf.gun.bulletSpeed)),
                                isPlayerBullet: false
                            }
                        });
                        wolf.engine.NewGameObjectWithScript(SPBullet, {
                            position: center.add(wolf.transform.right.scale(4)),
                            initialValues: {
                                damage: wolf.gun.damage,
                                velocity: wolf.velocity.add(wolf.transform.forward.scale(wolf.gun.bulletSpeed)),
                                isPlayerBullet: false
                            }
                        });
                    }
                }
            }
        },
        {
            delay: 0,
            callback: () => {
                this.engine.NewGameObjectWithScript<Hive>(Hive, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980)),
                    initialValues: {
                        
                        _state: 3,
                        travelDest: this.engine.camera.add(Vector2.left.scale(this.engine.width/3))
                    }
                });
                this.engine.NewGameObjectWithScript<Hive>(Hive, {
                    position: SPPlayer.Singleton.transform.position.add(Vector2.fromRadians(Random.float(0, 2*Math.PI)).scale(980)),
                    initialValues: {
                        
                        _state: 3,
                        travelDest: this.engine.camera.add(Vector2.right.scale(this.engine.width/3))
                    }
                });
            }
        },
        //#endregion
        {
            delay: 5,
            callback: () => {
                SPGameManager.Singleton.ChangeBGM(SoundByte.BGM1, 17.47);
                SPGameManager.Singleton.SetTitleText(`Congratulations
You've reached the end of the demo

Final score: ${SPPlayer.Singleton.totalExp.toLocaleString()}`, {
                    stay: 5
                });
            }
        },

        {
            delay: 7,
            callback: () => {
                SPGameManager.Singleton.SetTitleText(`You can refresh to play again; try a new progression route!`, {
                    stay: 11/4
                });
            }
        },

        {
            delay: 11/4+2,
            callback: () => {
                SPGameManager.Singleton.SetTitleText(`Thanks for playing\nBe on the lookout for more!`, {
                    stay: 5
                });
            }
        },
        {
            delay: 7+3,
            callback: () => {
                SPPlayer.Singleton.Die();
            }
        },
    ];
    eventIndex = 0;

    Init(): void {
        this.gameObject.layer = 1;
    }

    Update(): void {
        if (this.eventIndex >= this.events.length || SPGameManager.Singleton.state !== SPGameState.InGame) return;

        if (this.engine.GetGameObjectsBehaviors<SPBogey>(SPBogey).filter(v => (v instanceof SmartBogey ? !v.isFriendly : true)).length === 0 && !this.active) {
            this.active = true;
            setTimeout(() => {
                this.events[this.eventIndex].callback();
                this.active = false;
                this.eventIndex++;
            }, this.events[this.eventIndex].delay * 1000);
        }
    }

    Draw(): void {
        this.engine.drawTexts([`${Math.floor(this.timeAlive)}`], new Vector2(0, 0), {
            color: 'white'
        });
    }

}